import { useCities } from '@/lib/data/services';

/**
 * City selection, as a plain dropdown.
 *
 * Not a geocoded address lookup, and not "detect my location". A fixed list is
 * how people in India actually search — by city, then by locality — and it
 * costs no API key, no per-request bill, and no permission prompt that half of
 * users decline anyway. Coordinates and radius search get added the day
 * someone genuinely needs "photographers within 5km".
 *
 * Reasoning in docs/10-PIVOT-MULTI-SERVICE.md §3.
 */
export default function CityPicker({
  value,
  onChange,
  label = 'City',
}: {
  value: string | null;
  onChange: (slug: string | null) => void;
  label?: string;
}) {
  const cities = useCities();

  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="text-[var(--ink-2)]">{label}</span>
      <select
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value || null)}
        className="rounded-lg px-3 py-2 text-sm transition-colors duration-150"
        style={{
          background: 'var(--surface)',
          color: 'var(--ink)',
          border: '1px solid var(--line)',
        }}
      >
        <option value="">Anywhere</option>
        {cities.map((c) => (
          <option key={c.id} value={c.slug}>
            {c.name}
          </option>
        ))}
      </select>
    </label>
  );
}
